import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listGroupcalendar = ({teamIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('recovery/team/groupcalendar/search', {
    teamIds,
    folderId,
    snapshotDateTime,
    pagination,
    searchTerm: trimString(searchTerm)
  })
}

const listBreadcrumps = ({teamId, folderId, snapshotDate}) => {
  return POST('recovery/team/groupcalendar/breadcrumbs', {teamId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('recovery/team/groupcalendar/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('recovery/team/groupcalendar/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

export {
  listGroupcalendar,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
